import { I18n } from "i18n-js";

// Create a new I18n instance
const i18n = new I18n();

// CRITICAL: Set up I18n globally BEFORE loading locale files
i18n.translations = {};
i18n.extend = (target, source) => {
  return Object.assign(target, source);
};

// Make it globally available
if (typeof window !== "undefined") {
  window.I18n = i18n;
}
globalThis.I18n = i18n;

// Helper function to get locale from various sources
const getLocale = () => {
  // Try to get from body data attribute
  if (
    typeof document !== "undefined" &&
    document.body &&
    document.body.dataset.locale
  ) {
    return document.body.dataset.locale;
  }

  // Fallback to URL parsing
  if (typeof window !== "undefined") {
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    const supportedLocales = ["lv", "ru"];
    if (supportedLocales.includes(pathParts[0])) {
      return pathParts[0];
    }
  }

  return "lv";
};

// Load locale files dynamically (not with import, which is hoisted)
// This ensures I18n is set up before the locale files execute
const loadLocales = async () => {
  try {
    // Dynamic imports execute in order and after this module's code
    await import("./locales/lv.js");
    await import("./locales/ru.js");
    // Set locale after translations are loaded
    const currentLocale = getLocale();
    i18n.locale = currentLocale;
    i18n.defaultLocale = "lv";
  } catch (error) {
    console.error("Failed to load locale files:", error);
  }
};

// Start loading locales immediately
loadLocales();

// Set initial locale (will use empty translations until locales load)
const currentLocale = getLocale();
i18n.locale = currentLocale;
i18n.defaultLocale = "lv";

// Update locale again when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  const locale = getLocale();
  i18n.locale = locale;

  // Update HTML lang attribute
  if (document.documentElement) {
    document.documentElement.lang = locale;
  }
});

export default i18n;
